<template>
    <div>
        <app-finalizacao-associar-desp-viagens
            :finalizacoesServicos="obterFinalizacoesServicos()"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
            :finalizacao="finalizacao"
        ></app-finalizacao-associar-desp-viagens>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import FinalizacaoAssociarDespViagens from '@/app/credenciados/componentes/finalizacoes/FinalizacaoAssociarDespViagens'

export default {
	props: {
		finalizacao: {
			type: Object
		}
	},

	data() {
		return {}
	},

	methods: {
		obterFinalizacoesServicos() {
			return FinalizacoesServicos
		},

		obterFinalizacaoAtualizada() {
			this.$emit('obterFinalizacaoAtualizada')
		}
	},

	components: {
		AppFinalizacaoAssociarDespViagens: FinalizacaoAssociarDespViagens
	}
}
</script>
